import { pageInfo } from './../api';
const trackMateriel = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
  }
}
export default trackMateriel



// WEBPACK FOOTER //
// ./src/page/md/trackMateriel/store/trackMateriel.store.js